import { render, staticRenderFns } from "./CollegeSectionEdit.vue?vue&type=template&id=62d44001&scoped=true&"
import script from "./CollegeSectionEdit.vue?vue&type=script&lang=js&"
export * from "./CollegeSectionEdit.vue?vue&type=script&lang=js&"
import style0 from "./CollegeSectionEdit.vue?vue&type=style&index=0&id=62d44001&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d44001",
  null
  
)

export default component.exports